module.exports = __webpack_public_path__ + "static/media/coffeehousecompany.9000703f.jpg";